import React from "react";
import { Navbar } from "../components/shared/Navbar";
import { Explore } from "./components/Explore";
import { ComprehensiveSecurityAssessment } from "./components/ComprehensiveSecurityAssessment";
import { RobustInfra } from "./components/RobustInfra";
import { Defense } from "./components/Defense";
import { Compliance } from "./components/Compliance";
import { Cta7 } from "./components/Cta7";
import { Footer2 } from "../components/shared/Footer2";
import { ServiceBanner } from "./components/ServiceBanner";
import {WarumUns} from "./components/WarumUns"
import backgroundImage from '../assets/images/OfficeSpace.jpg';

export default function Services() {
  return (
    <div className="font-noto">
       <div
       id="services-header"  
       style={{ backgroundImage: `url(${backgroundImage})`,backgroundColor: `rgba(0,0,0,0.5)` }}
       className="bg-cover  bg-center bg-no-repeat min-h-600px]">
        <Navbar />
        <ServiceBanner />
       </div>
       <Explore />
      <ComprehensiveSecurityAssessment />
      <RobustInfra />
      <WarumUns/>
      <Defense />
      <Compliance />
     
      <Footer2 />
    </div>
  );
}
